export default __webpack_public_path__ + "static/media/SIW400G_T050_T060_T075_W00_W01.dfadfaa4.webp";